export default __webpack_public_path__ + "static/media/IMG-20240729-WA0026.399393f1.jpg";